// extracted by mini-css-extract-plugin
export default {"active":"jLvkTy2pjiRME2XZ9eXp","inactive":"Fffpf5dvUJPwNXCqHSP3"};